import store from '@/store'

export const checkRequireAuth = async (to, from, next) => {
  try {
    await store.dispatch('auth/validaLogado')
    if (!to.meta.requireAuth) return next({ name: 'default' })
    return next()
  } catch (e) {
    if (to.meta.requireAuth) return next({ name: 'login', query: { redirect: to.fullPath } })
    return next()
  }
}
